var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFinance1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 15.5518C0 8.6482 5.59644 3.05176 12.5 3.05176H35.7143C36.7005 3.05176 37.5 3.85125 37.5 4.83747V9.82841L11.9838 9.8284C10.751 9.8284 9.75167 10.8278 9.75167 12.0605C9.75167 13.2933 10.751 14.2927 11.9838 14.2927L39.0698 14.2927C39.1339 14.2927 39.1974 14.29 39.2601 14.2847L40.0431 14.2847C41.4639 14.2847 42.8265 14.8491 43.8312 15.8538C44.8359 16.8584 45.4003 18.221 45.4003 19.6418V22.9146H34.8633C31.9187 22.9146 28.6133 25.1459 28.6133 28.9668V35.3183C28.6133 39.1392 31.9187 41.3705 34.8633 41.3705H45.4003V44.6418C45.4003 46.0626 44.8359 47.4252 43.8312 48.4299C42.8265 49.4345 41.4639 49.9989 40.0431 49.9989L5.35714 49.999C3.93634 49.999 2.57373 49.4346 1.56907 48.4299C0.564412 47.4252 0 46.0626 0 44.6418V15.5518ZM34.8633 27.3786H47.3633C48.3495 27.3786 49.149 28.0895 49.149 28.9665V35.318C49.149 36.195 48.3495 36.9059 47.3633 36.9059H34.8633C33.8771 36.9059 33.0776 36.195 33.0776 35.318V28.9665C33.0776 28.0895 33.8771 27.3786 34.8633 27.3786Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinance1);
export default __webpack_public_path__ + "static/media/Finance-1.4dc157fd96499a3b045d849482986c08.svg";
export { ForwardRef as ReactComponent };